import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.FormTrackingWidgets = routerStyxie({ actions: ['index', 'new', 'show', 'edit']})
